import React, { useState, useEffect } from 'react';
import { Button, TextField, Box, Typography, Container, Paper, CircularProgress, Alert } from '@mui/material';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import FetchService from '../../services/FetchService';
import endpoints from '../../environment/endpoints';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const fetchService = new FetchService();

  useEffect(() => {
    const qEmail = searchParams.get('email');
    const qToken = searchParams.get('token');
    if (qEmail && qToken) {
      setEmail(qEmail);
      setToken(qToken);
    } else {
      setError('Invalid password reset link.');
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !token) {
        setError('Missing token or email.');
        return;
    }

    setError('');
    setMessage('');
    setIsLoading(true);

    const res = await fetchService.post(endpoints.resetPassword, { email, token, newPassword });
    if (res.success && res.data?.message) {
      setMessage('Password reset successful! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } else {
      setError(res.data?.message || res.errors || 'Error resetting password.');
    }
    setIsLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom fontWeight="bold" color="secondary">
          Set New Password
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        {message && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{message}</Alert>}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="New Password"
            type="password"
            autoFocus
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            helperText="Password must be at least 6 characters long."
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            disabled={isLoading || !email || !token}
            sx={{ mt: 3, mb: 2, padding: 1.5, fontSize: '1.1rem' }}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Reset Password'}
          </Button>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography variant="body2">
              <Link to="/login" style={{ color: '#FF3900', textDecoration: 'none', fontWeight: 'bold' }}>
                Back to Login
              </Link>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
